import React from "react";
import withShipment from "../../../../withShipment";

import './LocationSelectBox.css';
import Autocomplete from "@material-ui/lab/Autocomplete";
import {TextField} from "@material-ui/core";
// import {availableLocationsSelector} from "../../../../redux/selectors/settings";
// import {updateSelectedLocation} from "../../../../redux/actions/auth";
// import {selectedLocationIdSelector} from "../../../../redux/selectors/auth";
import PropTypes from "prop-types";


class LocationSelectBox extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedLocation: this.getSelectedLocation(),

            alternativeValues: this.props.alternativeValues ? this.props.alternativeValues : [],
            availableLocations: this.getAvailableLocations()
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.alternativeValues !== prevProps.alternativeValues ||
            this.props.selectedLocationId !== prevProps.selectedLocationId ||
            this.props.availableLocations !== prevProps.availableLocations) {
            let newLocation = this.getSelectedLocation()
            this.setState({
                selectedLocation: newLocation,
                alternativeValues: this.props.alternativeValues ? this.props.alternativeValues : [],
                availableLocations: this.getAvailableLocations()
            })
        }
    }

    getAvailableLocations = () => {
        let availableLocations = this.props.availableLocations ? this.props.availableLocations : []
        let alternativeValues = this.props.alternativeValues ? this.props.alternativeValues : []
        return availableLocations.filter(location => location.enabled).concat(alternativeValues.map(value => {return {name: value, shipAddressId: value}}))
    }

    getSelectedLocation = () => {
        let newSelectedLocation = this.props.availableLocations.find((value) => {return value.shipAddressId === this.props.selectedLocationId})
        if (newSelectedLocation) {
            return newSelectedLocation
        } else {
            return {}
        }
    }

    render() {
        return (
            <React.Fragment>

                <Autocomplete
                    className={"locationDateFields"}
                    options={this.state.availableLocations}
                    getOptionLabel={(entry) => entry.name || ''}
                    autoHighlight={true}
                    disableClearable
                    onChange={(event, value) => {

                        if (!this.state.alternativeValues?.includes(value.shipAddressId)) {
                            this.props.updateSelectedLocation(value.shipAddressId)
                        }
                        if (this.props.updateCallback)
                            this.props.updateCallback(value)
                    }}
                    blurOnSelect={true}

                    filterOptions={(options, state) => options}
                    value={this.props.selectedAlternativeValue ? this.props.selectedAlternativeValue : this.state.selectedLocation}

                    renderInput={(params) =>
                        <TextField
                            {...params}
                            label="Location"
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            name="locationSelect"
                        />
                    }
                />

            </React.Fragment>
        )
    }

}

LocationSelectBox.defaultProps = {

}

LocationSelectBox.propTypes = {
    selectedLocation: PropTypes.object
}

const mapStateToProps = (state) => ({
    // availableLocations: availableLocationsSelector(state),
    // selectedLocationId: selectedLocationIdSelector(state)
})

const actionCreators = {
  //  updateSelectedLocation
}

export default withShipment({
    mapStateToProps,
    actionCreators
}, LocationSelectBox);